



















import { Component, Vue } from "vue-property-decorator";
import { GET_CURRENT_USER_ROLE } from "@/store/getters-types";
import ChangePasswordBtn from "@/components/user-management/ChangePasswordBtn.vue";

@Component({
  components: { ChangePasswordBtn },
})
/**
 * A very simple profile site
 */
export default class userProfile extends Vue {
  /**
   * role of the logged in user
   */
  get currentUserRole(): string {
    return this.$store.getters[GET_CURRENT_USER_ROLE];
  }
}
